import {css} from "@panda/css";

import {SemanticSearchSignupForm} from "../../../auth/components/auth_card/SemanticSearchSignupForm";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {useSemanticSearchPostAuthNavigation} from "../../hooks/use_semantic_search_post_auth_navigation";

export const SemanticSearchAuthSignupForm = () => {
    const {completeAuthFlow} = useSemanticSearchPostAuthNavigation();

    const handleAuthSuccess = () => {
        void completeAuthFlow();
    };

    return (
        <div className={container}>
            <SemanticSearchSignupForm userSource={UserSource.REGISTRATION} socialAuthSuccess={handleAuthSuccess} emailAuthSuccess={handleAuthSuccess} />
        </div>
    );
};

const container = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5
});
import {css} from "@panda/css";

import {SemanticSearchSignupForm} from "../../../auth/components/auth_card/SemanticSearchSignupForm";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {useSemanticSearchPostAuthNavigation} from "../../hooks/use_semantic_search_post_auth_navigation";

export const SemanticSearchAuthSignupForm = () => {
    const {completeAuthFlow} = useSemanticSearchPostAuthNavigation();

    const handleAuthSuccess = () => {
        void completeAuthFlow();
    };

    return (
        <div className={container}>
            <SemanticSearchSignupForm userSource={UserSource.REGISTRATION} socialAuthSuccess={handleAuthSuccess} emailAuthSuccess={handleAuthSuccess} />
        </div>
    );
};

const container = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5
});
